"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALIZED_COUNTRIES = exports.DEFAULT_CURRENCY = exports.DEFAULT_LOCALE = exports.ORACLE_CLOUD_BASE_PATH = void 0;
exports.ORACLE_CLOUD_BASE_PATH = "https://cloud.oracle.com";
exports.DEFAULT_LOCALE = "en";
exports.DEFAULT_CURRENCY = "USD";
exports.LOCALIZED_COUNTRIES = [
    "us",
    "ca",
    "ar",
    "bz",
    "br",
    "cl",
    "co",
    "cr",
    "ec",
    "gt",
    "hn",
    "mx",
    "ni",
    "pa",
    "py",
    "pe",
    "pr",
    "uy",
    "au",
    "bd",
    "bt",
    "bn",
    "kh",
    "cn",
    "hk",
    "in",
    "id",
    "jp",
    "kr",
    "la",
    "my",
    "mv",
    "mn",
    "nz",
    "np",
    "pk",
    "ph",
    "sg",
    "lk",
    "tw",
    "th",
    "vn",
    "at",
    "be",
    "bg",
    "hr",
    "cz",
    "dk",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "hu",
    "ie",
    "it",
    "lv",
    "lt",
    "mt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "ru",
    "rs",
    "sk",
    "si",
    "es",
    "se",
    "ch",
    "tr",
    "ua",
    "uk",
    "bh",
    "eg",
    "il",
    "jo",
    "kw",
    "lb",
    "om",
    "qa",
    "sa",
    "ae",
    "ye",
    "dz",
    "gh",
    "ke",
    "ma",
    "ng",
    "sn",
    "za",
];
//# sourceMappingURL=constants.js.map